import Dexie, { type Table } from 'dexie'
import type { Metadata, QueueItemT } from '@/lib/types/bgSyncTypes.ts'

export interface NativeQueueEntry {
  id?: number
  queueName: 'fastQueue' | 'mediaQueue'
  url: string
  method: 'POST' | 'PATCH'
  headers: Record<string, string>
  body: string | null
  timestamp: number
  metadata: Metadata
}

export class NativeQueueDatabase extends Dexie {
  requests!: Table<NativeQueueEntry>
  blobs!: Table<{ id: string; blob: Blob }>

  constructor() {
    super('native-sync-queue')
    this.version(1).stores({
      requests: '++id, queueName, timestamp, [metadata.requestUUID], [metadata.fileUUID]',
      blobs: 'id',
    })
  }
}

export const nativeQueueDb = new NativeQueueDatabase()

export function convertToQueueItem(entry: NativeQueueEntry): QueueItemT {
  let bodyObj: Record<string, unknown> = {}
  if (entry.body) {
    try {
      bodyObj = JSON.parse(entry.body)
    } catch {
      bodyObj = {}
    }
  }

  return {
    requestData: {
      url: entry.url,
      headers: entry.headers,
      body: bodyObj,
      method: entry.method,
      referrer: '',
      referrerPolicy: 'strict-origin-when-cross-origin',
      mode: 'cors',
      credentials: 'include',
      cache: 'default',
      redirect: 'follow',
      integrity: '',
      keepalive: false,
    },
    timestamp: entry.timestamp,
    metadata: entry.metadata,
    id: entry.id ?? 0,
    queueName: entry.queueName,
  }
}
